import { GuardedDeletionService } from 'orchestrator';
import { Component, inject } from '@angular/core';
import { FlowTypeService } from '../proxy/planning/controllers';
import { ListService } from '@abp/ng.core';
import {
  CardComponent,
  CardBodyComponent,
  ConfirmationService,
} from '@abp/ng.theme.shared';
import {
  FlowTypeCreateDto,
  FlowTypeDto,
  FlowTypeExcelDownloadDto,
  FlowTypeUpdateDto,
} from '../proxy/planning/dtos/flow-type';
import { FLOWTYPE_CONFIG, FLOWTYPE_FIELDS } from './flow-type.config';
import { BaseCrudComponent, CrudPage, GenericForm } from '@zendra/shared';

@Component({
  selector: 'app-flow-type',
  imports: [
    CardComponent,
    CardBodyComponent,
    CrudPage,
    GenericForm,
  ],
  providers: [ListService, FlowTypeService, ConfirmationService],
  templateUrl: './flow-type.html',
  styleUrl: './flow-type.scss',
})
export class FlowType extends BaseCrudComponent<
  FlowTypeDto,
  FlowTypeCreateDto,
  FlowTypeUpdateDto,
  FlowTypeExcelDownloadDto
> {
  private readonly guardedDeletion = inject(GuardedDeletionService);
  service = {
    ...inject(FlowTypeService),
    deleteByIds: (ids: number[]) => this.guardedDeletion.deleteByIds('FlowType', ids),
  };
  config = FLOWTYPE_CONFIG;
  fields = FLOWTYPE_FIELDS;

  protected prepareUpdateDto(data: any, selected: FlowTypeDto): FlowTypeUpdateDto {
    return {
      name: data.name,
      concurrencyStamp: selected.concurrencyStamp,
    };
  }

  protected getEntityName(): string {
    return 'FlowType';
  }
}
